export default __webpack_public_path__ + "static/12-45b7bb8e1fc7515fc6e32d8c8bff5941.jpg";